import * as _ from 'lodash'
import {
  GET_CURRENT_USER_REQUEST,
  NO_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
  CURRENT_USER_ALREADY_SET,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  CLEAR_CURRENT_USER_STATUS,
  CURRENT_USER_REGISTRATION_COMPLETE,
  UPDATE_APPRAISER_REQUEST,
  UPDATE_APPRAISER_SUCCESS,
  UPDATE_APPRAISER_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  UNSET_CURRENT_USER,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILURE,
  CREATE_COMMENT_REQUEST,
  CREATE_COMMENT_SUCCESS,
  CREATE_COMMENT_FAILURE,
  UPDATE_COMMENT_REQUEST,
  UPDATE_COMMENT_SUCCESS,
  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  UPLOAD_USER_DOCS_REQUEST,
  UPLOAD_USER_DOCS_SUCCESS,
  UPLOAD_USER_DOCS_FAILURE,
  CREATE_COMPANY_INVITATIONS_REQUEST,
  CREATE_COMPANY_INVITATIONS_SUCCESS,
  CREATE_COMPANY_INVITATIONS_FALURE,
  RESEND_COMPANY_INVITATIONS_REQUEST,
  RESEND_COMPANY_INVITATIONS_FAILURE,
  RESEND_COMPANY_INVITATIONS_SUCCESS,
  DELETE_COMPANY_INVITATIONS_REQUEST,
  DELETE_COMPANY_INVITATIONS_SUCCESS,
  DELETE_COMPANY_INVITATIONS_FALURE,
  CHANGE_USER_ROLE,
  GET_NOTIFICATIONS_SUCCESS,
  VIEW_NOTIFICATIONS,
  RECEIVE_NOTIFICATIONS,
  UPDATE_INVITATIONS_REQUEST,
  UPDATE_INVITATIONS_SUCCESS,
  UPDATE_INVITATIONS_FAILURE,
  SEND_BOX_NOTIFICATION,
  CLEAR_BOX_NOTIFICATION,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAILURE,
  VERIFY_APPRAISER_REQUEST,
  VERIFY_APPRAISER_SUCCESS,
  VERIFY_APPRAISER_FAILURE,
  UPDATE_USER_COMPANY_ROLE_REQUEST,
  UPDATE_USER_COMPANY_ROLE_SUCCESS,
  UPDATE_USER_COMPANY_ROLE_FAILURE,
  REMOVE_USER_FROM_COMPANY_REQUEST,
  REMOVE_USER_FROM_COMPANY_SUCCESS,
  REMOVE_USER_FROM_COMPANY_FAILURE,
  GET_COMPANY_APPRAISERS_REQUEST,
  GET_COMPANY_APPRAISERS_SUCCESS,
  GET_COMPANY_APPRAISERS_FAILURE,
  UPDATE_COMPANY_CLIENT_REQUEST,
  UPDATE_COMPANY_CLIENT_SUCCESS,
  UPDATE_COMPANY_CLIENT_FAILURE,
  DELETE_COMPANY_CLIENT_REQUEST,
  CREATE_COMPANY_CLIENT_REQUEST,
  CREATE_COMPANY_CLIENT_SUCCESS,
  CREATE_COMPANY_CLIENT_FAILURE,
  EDIT_COMPANY_CLIENT_TAGS_REQUEST,
  EDIT_COMPANY_CLIENT_TAGS_SUCCESS,
  EDIT_COMPANY_CLIENT_TAGS_FAILURE,
  VERIFY_INVITATION_EMAILS_REQUEST,
  VERIFY_INVITATION_EMAILS_SUCCESS,
  VERIFY_INVITATION_EMAILS_FAILURE,
  SUBMIT_UPDATED_CONSENT_REQUEST,
  SUBMIT_UPDATED_CONSENT_SUCCESS,
  SUBMIT_UPDATED_CONSENT_FAILURE,
  UPDATE_APPRAISER_COVERAGE_REQUEST,
  UPDATE_APPRAISER_COVERAGE_SUCCESS,
  UPDATE_APPRAISER_COVERAGE_FAILURE,
  GET_APPRAISERS_COVERAGE_REQUEST,
  GET_APPRAISERS_COVERAGE_SUCCESS,
  GET_APPRAISERS_COVERAGE_FAILURE,
  UPLOAD_COMPANY_EO_REQUEST,
  UPLOAD_COMPANY_EO_SUCCESS,
  UPLOAD_COMPANY_EO_FAILURE,
  GET_COMPANY_SUCCESS,
} from '../constants/actionTypes'
import {
  LOADING,
  SUCCEEDED,
  ERROR,
} from '@constants/fetchStatuses'

import 'isomorphic-fetch'
import jwtDecode from 'jwt-decode'
import { logoutUser } from './auth'
import processError from '../helpers/processError'
import analytics from '../helpers/segmentAnalytics'
import * as Sentry from '@sentry/react'

function requestCurrentUser() {
  return {
    type: GET_CURRENT_USER_REQUEST,
    isFetching: true,
    status: LOADING,
  }
}

function noCurrentUser() {
  return {
    type: NO_CURRENT_USER,
    isFetching: false,
    currentUser: {},
    status: SUCCEEDED,
  }
}

function receiveCurrentUser(currentUser) {
  return {
    type: GET_CURRENT_USER_SUCCESS,
    isFetching: false,
    currentUser,
    status: SUCCEEDED,
  }
}

function getCurrentUserError(message) {
  return {
    type: GET_CURRENT_USER_FAILURE,
    isFetching: false,
    message,
    status: ERROR,
  }
}

function currentUserAlreadySet() {
  return {
    type: CURRENT_USER_ALREADY_SET,
    isFetching: false,
    status: SUCCEEDED,
  }
}

function currentUserRegistrationComplete() {
  return {
    type: CURRENT_USER_REGISTRATION_COMPLETE,
  }
}

// force used to reget current user after updating
export function getCurrentUser(force, justRegistered) {
  const authToken = localStorage.getItem('reggora_auth_token')
  if (typeof authToken !== 'string') {
    return dispatch => {
      dispatch(requestCurrentUser())
      dispatch(noCurrentUser())
    }
  }
  const userId = jwtDecode(authToken).user_id
  const userUrl = `${SERVER_BASE_URL}/api/users/${userId}/web`
  const companyUrl = `${SERVER_BASE_URL}/api/users/${userId}/company`
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }

  return (dispatch, getState) => {
    dispatch(requestCurrentUser())

    if (force || !getState().currentUser.currentUser.id) {
      return Promise.all([fetch(userUrl, config), fetch(companyUrl, config)])
        .then((response) => {
          return Promise.all(response.map(r => r.json().then((result) => ({ result, response: r }))))
            .then((responses) => {
              const { result, response } = responses[0]
              const { result: resultCompany, response: responseCompany } = responses[1]
              if (!response.ok || !responseCompany.ok) {
                dispatch(getCurrentUserError(processError(result)))
                if (response.status === 401) {
                  // Authorization failure, meaning a bad token, so
                  // log the user out
                  return dispatch(logoutUser())
                }
                return Promise.reject(result)
              } else {
                const user = result
                user.company = resultCompany
                dispatch(receiveCurrentUser(user))
                if (justRegistered) { dispatch(currentUserRegistrationComplete()) }
                analytics.userLogIn(user)
              }
            }).catch((_) => dispatch(logoutUser()))
        }).catch((_) => dispatch(logoutUser()))
    } else {
      dispatch(currentUserAlreadySet())
    }
  }
}


export function clearStatus() {
  return {
    type: CLEAR_CURRENT_USER_STATUS,
    status: '',
  }
}


function requestUpdateUser() {
  return {
    type: UPDATE_USER_REQUEST,
    isUpdating: true,
    status: LOADING,
  }
}

function receiveUpdateUser(userUpdates) {
  return {
    type: UPDATE_USER_SUCCESS,
    isUpdating: false,
    userUpdates: userUpdates,
    status: SUCCEEDED,
  }
}

function updateUserError(message) {
  return {
    type: UPDATE_USER_FAILURE,
    isUpdating: false,
    status: ERROR,
    message,
  }
}

export function updateUser(userUpdates, update_type, dispatchActions = true, additionalStateUpdates = {}) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({ ...userUpdates, update_type: update_type }),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.id
    const url = `${SERVER_BASE_URL}/api/users/${id}`
    if (dispatchActions) { dispatch(requestUpdateUser()) }
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateUserError(processError(result)))
              return Promise.reject(result)
            } else {
              if (!dispatchActions) { return }

              const oldUser = getState().currentUser.currentUser
              const newUser = {
                ...oldUser,
                ...userUpdates,
                ...additionalStateUpdates,
              }

              if (oldUser.using_form_software && !userUpdates.using_form_software) {
                // switched from using form software to not, so potentially switch them to manager
                if (oldUser.available_roles.indexOf('manager') > -1 || oldUser.available_roles.indexOf('admin') > -1) {
                  newUser.role = 'manager'
                }
              }

              dispatch(receiveUpdateUser(newUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function requestUpdateAppraiser() {
  return {
    type: UPDATE_APPRAISER_REQUEST,
    isUpdating: true,
    status: LOADING,
  }
}

function receiveUpdateAppraiser(userUpdates) {
  return {
    type: UPDATE_APPRAISER_SUCCESS,
    isUpdating: false,
    userUpdates: userUpdates,
    status: SUCCEEDED,
  }
}

function updateAppraiserError(message) {
  return {
    type: UPDATE_APPRAISER_FAILURE,
    isUpdating: false,
    message,
    status: ERROR,
  }
}

export function editAppraiser(userUpdates, update_type) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({ ...userUpdates, update_type: update_type }),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch) => {
    const url = `${SERVER_BASE_URL}/api/users/${userUpdates.id}/appraiser`
    dispatch(requestUpdateAppraiser())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateAppraiserError(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(receiveUpdateAppraiser(result))
            }
          }).catch((err) => console.log(err))
      })
  }
}

export function uploadAppraiserEO(eo, userId) {
  const form = new FormData()
  form.set('eo_file', eo, eo.name)
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: form,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
    },
  }

  return (dispatch) => {
    const url = `${SERVER_BASE_URL}/api/users/${userId}/eo`
    dispatch(requestUpdateAppraiser())
    return fetch(url, config)
      .then((response) => {
        return response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateAppraiserError(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(receiveUpdateAppraiser(result.appraiser))
              return result.appraiser
            }
          }).catch((err) => console.log(err))
      })
  }
}

function changePasswordRequest() {
  return {
    type: CHANGE_PASSWORD_REQUEST,
    isChanging: true,
  }
}

function changePasswordSuccess() {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    isChanging: false,
  }
}

function changePasswordFailure(message) {
  return {
    type: CHANGE_PASSWORD_FAILURE,
    isChanging: false,
    message,
  }
}

export function changePassword(old_password, new_password) {
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify({
      old_password,
      new_password,
    }),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/password`
    dispatch(changePasswordRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(changePasswordFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(changePasswordSuccess())
            }
          }).catch((err) => console.log(err))
      })
  }
}

export function unsetCurrentUser() {
  return {
    type: UNSET_CURRENT_USER,
    currentUser: {},
  }
}

function createClientRequest() {
  return {
    type: CREATE_CLIENT_REQUEST,
    isCreatingClient: true,
  }
}

function createClientSuccess(client) {
  return {
    type: CREATE_CLIENT_SUCCESS,
    isCreatingClient: false,
    client,
  }
}

function createClientFailure(message) {
  return {
    type: CREATE_CLIENT_FAILURE,
    isCreatingClient: false,
    message,
  }
}

export function createClient(client) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify(client),
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/clients`
    dispatch(createClientRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(createClientFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(createClientSuccess(client))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function changeUserRoleSuccess(role) {
  return {
    type: CHANGE_USER_ROLE,
    role,
  }
}

export function changeUserRole(role) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({ update_type: 'role_update', role: role }),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.id
    const url = `${SERVER_BASE_URL}/api/users/${id}`
    dispatch(requestUpdateUser())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              return Promise.reject(result)
            } else {
              dispatch(changeUserRoleSuccess(role))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function requestVerifyAppraiserRecord() {
  return {
    type: VERIFY_APPRAISER_REQUEST,
    isVerifyingAppraiser: true,
  }
}

function verifyAppraiserSuccess(companyAppraisers) {
  return {
    type: VERIFY_APPRAISER_SUCCESS,
    isVerifyingAppraiser: false,
    companyAppraisers,
  }
}

function verifyAppraiserFailure(message) {
  return {
    type: VERIFY_APPRAISER_FAILURE,
    isVerifyingAppraiser: false,
    message,
  }
}


export function verifyAppraiserRecords(appraiserId) {
  const url = `${SERVER_BASE_URL}/api/companies/appraiser/${appraiserId}`
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    dispatch(requestVerifyAppraiserRecord())
    return fetch(url, config)
      .then((response) => {
        return response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(verifyAppraiserFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const companyAppraisers = [...getState().currentUser.companyAppraisers]
              const appraiser = result
              let index = 0
              for (const app of companyAppraisers) {
                if (app.id === appraiser.id) {
                  companyAppraisers[index] = appraiser
                }
                index++
              }
              dispatch(verifyAppraiserSuccess(companyAppraisers))
            }
          }).catch((err) => console.log(err))
      })
  }
}

export function getNotifications() {
  const authToken = localStorage.getItem('reggora_auth_token')
  if (typeof authToken !== 'string') {
    return dispatch => {
      dispatch(noCurrentUser())
    }
  }
  const userId = jwtDecode(authToken).user_id
  const url = `${SERVER_BASE_URL}/api/notifications/${userId}`
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `bearer ${authToken}`,
    },
  }
  return (dispatch) => {
    return fetch(url, config).then(response => {
      response.json().then(result => ({ result, response }))
        .then(({ result, response }) => {
          if (!response.ok) {
            return Promise.reject(result)
          } else {
            dispatch(getNotificationsSuccess(result, []))
          }
        }).catch(err => console.log(err))
    })
  }
}

function getNotificationsSuccess(notifications, invitations) {
  notifications.forEach(notification => {
    delete notification.user
  })
  return {
    type: GET_NOTIFICATIONS_SUCCESS,
    notifications,
    invitations,
  }
}

export function receiveNotifications(notifications, invitations) {
  const action = {
    type: RECEIVE_NOTIFICATIONS,
  }
  if (notifications) {
    action.notifications = notifications
  }
  if (invitations) {
    action.invitations = invitations
  }
  return action
}

function viewNotificationsSuccess(notifications) {
  return {
    type: VIEW_NOTIFICATIONS,
    notifications,
  }
}

export function viewNotifications(notifications) {
  return (dispatch, getState) => {
    let notifications_to_view = notifications
    notifications_to_view = _.filter(notifications_to_view, (n) => !n.viewed || n.viewed === 'None')
    const notification_ids_to_view = notifications_to_view.map(n => n.id)
    const config = {
      method: 'PUT',
      accept: 'application/json',
      body: JSON.stringify({ id: notification_ids_to_view }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
        'content-type': 'application/json',
      },
    }

    const authToken = localStorage.getItem('reggora_auth_token')
    if (typeof authToken !== 'string') {
      return dispatch => {
        dispatch(noCurrentUser())
      }
    }
    const url = `${SERVER_BASE_URL}/api/notifications/viewed`
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              console.log('an error occured', result)
              return Promise.reject(result)
            } else {
              const allNotifications = [...getState().currentUser.notifications]
              allNotifications.forEach(n => {
                if (notification_ids_to_view.includes(n.id)) {
                  n.viewed = true
                }
              })
              dispatch(viewNotificationsSuccess(allNotifications))
            }
          }).catch((err) => console.log(err))
      })
  }
}

export function showBoxNotification(notification) {
  // make sure the notification has a unique id
  if (!notification.id) {
    notification.id = new Date().getTime()
  }
  return dispatch => {
    dispatch(sendBoxNotification(notification))
    setTimeout(() => dispatch(clearBoxNotificationById(notification.id)), 100)
  }
}

function sendBoxNotification(notification) {
  return {
    type: SEND_BOX_NOTIFICATION,
    notification,
  }
}

function clearBoxNotificationById(id) {
  return {
    type: CLEAR_BOX_NOTIFICATION,
    id,
  }
}

function requestUpdateInvitation() {
  return {
    type: UPDATE_INVITATIONS_REQUEST,
    isUpdatingInvitations: true,
  }
}

function updateInvitationsSuccess(currentUser) {
  return {
    type: UPDATE_INVITATIONS_SUCCESS,
    isUpdatingInvitations: false,
    currentUser,
  }
}

function updateInvitationFailure(message) {
  return {
    type: UPDATE_INVITATIONS_FAILURE,
    isUpdatingInvitations: false,
    message,
  }
}

export function updateInvitation(invitation_id, action) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({}),
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/invitations/${invitation_id}/${action}`
    dispatch(requestUpdateInvitation())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              console.log('update inv', result)
              dispatch(updateInvitationFailure(processError(result)))
              const box_notification = {
                type: 'error',
                title: 'There was an error while processing your request',
                description: 'Please try again',
              }
              dispatch(showBoxNotification(box_notification))
              return Promise.reject(result)
            } else {
              const currentUserStore = getState().currentUser
              const currentUser = currentUserStore.currentUser

              let invitationIndex
              let newCompany
              let newRoles
              for (let i = 0; i < currentUser.invitations.length; i++) {
                const invite = currentUser.invitations[i]
                if (invite.id === invitation_id) {
                  invitationIndex = i
                  newCompany = invite.company
                  newRoles = invite.role
                  break
                }
              }
              currentUser.invitations.splice(invitationIndex, 1)
              let box_notification
              if (action === 'accept') {
                currentUser.company = newCompany
                currentUser.available_roles = newRoles
                if (newRoles.indexOf('manager') > -1) {
                  currentUser.role = 'manager'
                }
                box_notification = {
                  type: 'success',
                  notification_type: 'invitation_accept_success',
                  title: 'Successfully accepted the invitation',
                  description: 'Invitation was successfully accepted',
                }
              } else {
                box_notification = {
                  type: 'success',
                  notification_type: 'invitation_denied_success',
                  title: 'Successfully declined the invitation',
                  description: 'Invitation was successfully declined.',
                }
              }
              dispatch(updateInvitationsSuccess(currentUser))

              dispatch(showBoxNotification(box_notification))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function updateClientRequest() {
  return {
    type: UPDATE_CLIENT_REQUEST,
    isUpdatingClient: true,
  }
}

function updateClientSucess(currentUser) {
  return {
    type: UPDATE_CLIENT_SUCCESS,
    isUpdatingClient: false,
    currentUser,
  }
}

function updateClientFailure(message) {
  return {
    type: UPDATE_CLIENT_FAILURE,
    isUpdatingClient: false,
    message,
  }
}

export function updateClient(name, updates) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify(updates),
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/clients/${name}`
    dispatch(updateClientRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateClientFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const currentUser = { ...getState().currentUser.currentUser }
              const clients = currentUser.clients
              for (let i = 0; i < clients.length; i++) {
                const client = clients[i]
                if (client.name === name) {
                  clients[i] = {
                    ...client,
                    ...updates,
                  }
                  break
                }
              }
              dispatch(updateClientSucess(currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function deleteClientRequest() {
  return {
    type: DELETE_CLIENT_REQUEST,
    isDeletingClient: true,
  }
}

function deleteClientSucess(currentUser) {
  return {
    type: DELETE_CLIENT_SUCCESS,
    isDeletingClient: false,
    currentUser,
  }
}

function deleteClientFailure(message) {
  return {
    type: DELETE_CLIENT_FAILURE,
    isDeletingClient: false,
    message,
  }
}

export function deleteClient(name) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'DELETE',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/clients/${name}`
    dispatch(deleteClientRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(deleteClientFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const currentUser = { ...getState().currentUser.currentUser }
              const clients = currentUser.clients
              currentUser.clients = clients.filter(client => {
                return client.name !== name
              })
              dispatch(deleteClientSucess(currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function uploadUserDocsRequest() {
  return {
    type: UPLOAD_USER_DOCS_REQUEST,
  }
}

function uploadUserDocsSuccess(client) {
  return {
    type: UPLOAD_USER_DOCS_SUCCESS,
  }
}

function uploadUserDocsFailure() {
  return {
    type: UPLOAD_USER_DOCS_FAILURE,
  }
}

export function updateUserDocs(file, type) {
  const authToken = localStorage.getItem('reggora_auth_token')
  const data = new FormData()
  data.append(type + '_file', file, file.name)
  const config = {
    method: 'PUT',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    body: data,
  }
  return (dispatch) => {
    const url = `${SERVER_BASE_URL}/api/users/` + type
    dispatch(uploadUserDocsRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(uploadUserDocsFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(uploadUserDocsSuccess(result))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function createCommentRequest() {
  return {
    type: CREATE_COMMENT_REQUEST,
    isCreatingComment: true,
  }
}

function createCommentSuccess(currentUser) {
  return {
    type: CREATE_COMMENT_SUCCESS,
    isCreatingComment: false,
    currentUser,
  }
}

function createCommentFailure(message) {
  return {
    type: CREATE_COMMENT_FAILURE,
    isCreatingComment: false,
    message,
  }
}

export function createComment(field, text) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify({ text }),
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const user = getState().currentUser.currentUser
    const id = user.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/canned_comments/${field}`
    dispatch(createCommentRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(createCommentFailure(processError(result)))
              return Promise.reject(result)
            } else {
              if (!user.canned_comments[field]) {
                user.canned_comments[field] = []
              }
              user.canned_comments[field].push({ text })
              dispatch(createCommentSuccess(user))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function updateCommentRequest() {
  return {
    type: UPDATE_COMMENT_REQUEST,
    isUpdatingComment: true,
  }
}

function updateCommentSuccess(currentUser) {
  return {
    type: UPDATE_COMMENT_SUCCESS,
    isUpdatingComment: false,
    currentUser,
  }
}

function updateCommentFailure(message) {
  return {
    type: CREATE_COMMENT_FAILURE,
    isUpdatingComment: false,
    message,
  }
}

export function updateComment(field, index, text) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({ text }),
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const user = getState().currentUser.currentUser
    const id = user.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/canned_comments/${field}/${index}`
    dispatch(updateCommentRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateCommentFailure(processError(result)))
              return Promise.reject(result)
            } else {
              // TODO update currentUser
              dispatch(updateCommentSuccess(user))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function deleteCommentRequest() {
  return {
    type: DELETE_COMMENT_REQUEST,
    isDeletingComment: true,
  }
}

function deleteCommentSuccess(currentUser) {
  return {
    type: DELETE_COMMENT_SUCCESS,
    isDeletingComment: false,
    currentUser,
  }
}

export function deleteComment(field, index) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'DELETE',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  return (dispatch, getState) => {
    const user = getState().currentUser.currentUser
    const id = user.id
    const url = `${SERVER_BASE_URL}/api/users/${id}/canned_comments/${field}/${index}`
    dispatch(deleteCommentRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(deleteComment(processError(result)))
              return Promise.reject(result)
            } else {
              // TODO update currentUser
              dispatch(deleteCommentSuccess(user))
            }
          }).catch((err) => console.log(err))
      })
  }
}


function requestCreateInvitation() {
  return {
    type: CREATE_COMPANY_INVITATIONS_REQUEST,
    isCreatingInvitation: true,
    invitationStatus: LOADING,
  }
}

function createInvitationError(message) {
  return {
    type: CREATE_COMPANY_INVITATIONS_FALURE,
    isCreatingInvitation: false,
    message,
    invitationStatus: ERROR,
  }
}

function createInvitationSuccess(invitations, invitedEmailErrors, companyAppraisers, currentUser) {
  return {
    type: CREATE_COMPANY_INVITATIONS_SUCCESS,
    isCreatingInvitation: false,
    invitations,
    invitedEmailErrors,
    companyAppraisers,
    currentUser,
    invitationStatus: SUCCEEDED,
  }
}

export function createInvitation(invitations, company_id) {
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify({ invitations: invitations, company: company_id }),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/invitations`
    dispatch(requestCreateInvitation())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(createInvitationError(processError(result)))
              return Promise.reject(result)
            } else {
              let createdInvitations = []
              let invitedEmailErrors = {}
              if (result.invitations) {
                createdInvitations = result.invitations
              }
              if (result.error_messages) {
                invitedEmailErrors = result.error_messages
              }
              const currentUser = getState().currentUser.currentUser
              let companyAppraisers = [...getState().currentUser.companyAppraisers]
              let companyManagers = [...currentUser.company.managers]
              if (result.appraisers) {
                companyAppraisers = companyAppraisers.concat(result.appraisers)
              }
              if (result.managers) {
                companyManagers = companyManagers.concat(result.managers)
              }

              currentUser.company = {
                ...currentUser.company,
                appraisers: [
                  ...currentUser.company.appraisers,
                  ...result.appraisers,
                ],
                managers: [
                  ...currentUser.company.managers,
                  ...companyManagers,
                ],
              }

              dispatch(createInvitationSuccess(createdInvitations, invitedEmailErrors, companyAppraisers, currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function requestResendInvitation() {
  return {
    type: RESEND_COMPANY_INVITATIONS_REQUEST,
    isCreatingInvitation: true,
    invitationStatus: LOADING,
  }
}

function resendInvitationError(message) {
  return {
    type: RESEND_COMPANY_INVITATIONS_FAILURE,
    isCreatingInvitation: false,
    message,
    invitationStatus: ERROR,
  }
}

function resendInvitationSuccess(id) {
  return {
    type: RESEND_COMPANY_INVITATIONS_SUCCESS,
    isCreatingInvitation: false,
    id,
    invitationStatus: SUCCEEDED,
  }
}


export function resendInvitation(user_id) {
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify(user_id),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/invitations/user/${user_id}`
    dispatch(requestResendInvitation())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(resendInvitationError(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(resendInvitationSuccess(user_id))
            }
          }).catch((err) => {
            Sentry.captureException(new Error(`Request Failed: ${err}`))
          })
      })
  }
}


function requestDeleteInvitation() {
  return {
    type: DELETE_COMPANY_INVITATIONS_REQUEST,
    isDeletingInvitation: true,
  }
}

function deleteInvitationError(message) {
  return {
    type: DELETE_COMPANY_INVITATIONS_FALURE,
    isDeletingInvitation: false,
    message,
  }
}

function deleteInvitationSuccess(currentUser) {
  return {
    type: DELETE_COMPANY_INVITATIONS_SUCCESS,
    isDeletingInvitation: false,
    currentUser,
  }
}

export function deleteInvitation(invitation_id, invitation_index) {
  const config = {
    method: 'DELETE',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/invitations/${invitation_id}`
    dispatch(requestDeleteInvitation())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(deleteInvitationError(processError(result)))
              return Promise.reject(result)
            } else {
              const currentUser = { ...getState().currentUser.currentUser }

              currentUser.company.pending_invitations.splice(invitation_index, 1)
              dispatch(deleteInvitationSuccess(currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}


function requestUpdateCompany() {
  return {
    type: UPDATE_COMPANY_REQUEST,
    isUpdatingCompany: true,
    status: LOADING,
  }
}

export function updateCompanySuccess(company) {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    isUpdatingCompany: false,
    company,
    status: SUCCEEDED,
  }
}

function updateCompanyFailure(message) {
  return {
    type: UPDATE_COMPANY_FAILURE,
    isUpdatingCompany: false,
    message,
    status: ERROR,
  }
}

export function updateCompany(company_data, company_id) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify(company_data),
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/${company_id}/update_company`
    dispatch(requestUpdateCompany())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateCompanyFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const existing_company = getState().currentUser.currentUser.company
              const new_company = {
                ...existing_company,
                ...company_data,
                payment_methods: result.company.payment_methods,
                missing_payment_method: result.company.missing_payment_method,
              }
              if (company_data && company_data.eo_insurance_company) {
                new_company.eo_information = {
                  insurance_company: company_data.eo_insurance_company,
                  expiration_date: company_data.eo_expiration_date,
                  prior_acts: company_data.eo_prior_acts,
                  claim_limit: company_data.eo_claim_limit,
                  aggregate_limit: company_data.eo_aggregate_limit,
                }
              }
              dispatch(updateCompanySuccess(new_company))

              /*
                    If this was successful then update the current user object with the new company data
                      let invitations = getState().currentUser.currentUser.invitations;
                      invitations = _.remove(invitations, (n) => {
                        return n.id === invitation_id;
                      });
                      dispatch(updateInvitationsSuccess(invitations, invitation_id));
                      const box_notification = {
                        type: 'success',
                        title: 'Successfully accepted the invitation',
                        description: 'Invitation was successfully accepted'
                      }
                      dispatch(showBoxNotification(box_notification));

                      */
            }
          }).catch((err) => console.log(err))
      })
  }
}

function requestUpdateAppraiserCoverage() {
  return {
    type: UPDATE_APPRAISER_COVERAGE_REQUEST,
    isUpdatingAppraiserCoverage: true,
    status: LOADING,
  }
}

export function updateAppraiserCoverageSuccess() {
  return {
    type: UPDATE_APPRAISER_COVERAGE_SUCCESS,
    isUpdatingAppraiserCoverage: false,
    status: SUCCEEDED,
  }
}

function updateUpdateAppraiserFailure(message) {
  return {
    type: UPDATE_APPRAISER_COVERAGE_FAILURE,
    isUpdatingAppraiserCoverage: false,
    message,
    status: ERROR,
  }
}

export function updateAppraiserCoverage(new_appraiser_data, appraiser_id) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify(new_appraiser_data),
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/orders/${appraiser_id}/coverage_area`
    dispatch(requestUpdateAppraiserCoverage())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateUpdateAppraiserFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(updateAppraiserCoverageSuccess())
            }
          }).catch((err) => console.log(err))
      })
  }
}

function getAppraisersCoverageRequest() {
  return {
    type: GET_APPRAISERS_COVERAGE_REQUEST,
    isFetchingAppraisersCoverage: true,
  }
}

function getAppraisersCoverageSuccess(result) {
  const currentIndividualCoverageArea = result.coverage
  const currentIndividualCoverageLevel = result.level
  return {
    type: GET_APPRAISERS_COVERAGE_SUCCESS,
    isFetchingAppraisersCoverage: false,
    currentIndividualCoverageArea,
    currentIndividualCoverageLevel,
  }
}

function getAppraisersCoverageFailure(message) {
  return {
    type: GET_APPRAISERS_COVERAGE_FAILURE,
    isFetchingAppraisersCoverage: false,
    message,
  }
}

export function getAppraisersCoverage(appraiser_id) {
  const authToken = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  return (dispatch, getState) => {
    dispatch(getAppraisersCoverageRequest())

    const url = `${SERVER_BASE_URL}/api/orders/${appraiser_id}/coverage_area`
    return fetch(url, config)
      .then(response => {
        response.json().then(result => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(getAppraisersCoverageFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(getAppraisersCoverageSuccess(result))
            }
          }).catch((err) => console.log(err))
      })
  }
}

export function updateStripeToken(stripe_token, company_id) {
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify({
      stripe_token,
    }),
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/${company_id}/stripe`
    dispatch(requestUpdateCompany())
    console.log('About to update stripe')
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateCompanyFailure(processError(result)))
              return Promise.reject(result)
            }
            dispatch(updateCompanySuccess(result))
          }).catch((err) => console.log(err))
      })
  }
}

function requestUploadCompanyEO() {
  return {
    type: UPLOAD_COMPANY_EO_REQUEST,
    status: LOADING,
  }
}

export function uploadCompanyEOSuccess(company) {
  return {
    type: UPLOAD_COMPANY_EO_SUCCESS,
    company,
    status: SUCCEEDED,
  }
}

function uploadCompanyEOFailure(message) {
  return {
    type: UPLOAD_COMPANY_EO_FAILURE,
    message,
    status: ERROR,
  }
}

export function uploadCompanyEO(eo, company_id) {
  const form = new FormData()
  form.set('eo', eo, eo.name)
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: form,
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/${company_id}/eo`
    dispatch(requestUploadCompanyEO())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(uploadCompanyEOFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const result_company = result.company
              console.log(result_company)
              const existing_company = getState().currentUser.currentUser.company
              const new_company = { ...existing_company, eo: result_company.eo }
              dispatch(uploadCompanyEOSuccess(new_company))
            }
          }).catch((err) => console.log(err))
      })
  }
}


function requestUserCompanyRoleUpdate() {
  return {
    type: UPDATE_USER_COMPANY_ROLE_REQUEST,
    isUpdatingCompanyUser: true,
  }
}

function updateUserCompanyRoleSuccess(company) {
  return {
    type: UPDATE_USER_COMPANY_ROLE_SUCCESS,
    isUpdatingCompanyUser: false,
    company,
  }
}

function updateUserCompanyRoleFailure(message) {
  return {
    type: UPDATE_USER_COMPANY_ROLE_FAILURE,
    isUpdatingCompanyUser: false,
    message,
  }
}

export function updateUserCompanyRole(company_id, user_id, roles) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({
      company_id: company_id,
      user_id: user_id,
      role: roles,
    }),
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/update-user`
    dispatch(requestUserCompanyRoleUpdate())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateUserCompanyRoleFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(updateUserCompanyRoleSuccess(result.company))
            }
          }).catch((err) => console.log(err))
      })
  }
}


function requestRemoveUserFromCompany() {
  return {
    type: REMOVE_USER_FROM_COMPANY_REQUEST,
    isRemovingUserFromCompany: true,
  }
}

function removeUserFromCompanySuccess(company) {
  return {
    type: REMOVE_USER_FROM_COMPANY_SUCCESS,
    isRemovingUserFromCompany: false,
    company,
  }
}

function removeUserFromCompanyFailure(message) {
  return {
    type: REMOVE_USER_FROM_COMPANY_FAILURE,
    isRemovingUserFromCompany: false,
    message,
  }
}

export function removeUserFromCompany(company_id, user_id) {
  const config = {
    method: 'DELETE',
    accept: 'application/json',
    body: JSON.stringify({
      company_id: company_id,
      user_id: user_id,
    }),
    headers: {
      Authorization: `bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/update-user`
    dispatch(requestRemoveUserFromCompany())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(removeUserFromCompanyFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(removeUserFromCompanySuccess(result.company))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function getCompanyAppraisersRequest() {
  return {
    type: GET_COMPANY_APPRAISERS_REQUEST,
    isFetchingCompanyAppraisers: true,
  }
}

function getCompanyAppraisersSuccess(result) {
  const companyAppraisers = result.appraisers
  const companyAppraisersCount = result.appraisers_count
  return {
    type: GET_COMPANY_APPRAISERS_SUCCESS,
    isFetchingCompanyAppraisers: false,
    companyAppraisers,
    companyAppraisersCount,
  }
}

function getCompanyAppraisersFailure(message) {
  return {
    type: GET_COMPANY_APPRAISERS_FAILURE,
    isFetchingCompanyAppraisers: false,
    message,
  }
}

function updateCompanyClientRequest() {
  return {
    type: UPDATE_COMPANY_CLIENT_REQUEST,
    isUpdatingClient: true,
  }
}

function updateCompanyClientSuccess(currentUser) {
  return {
    type: UPDATE_COMPANY_CLIENT_SUCCESS,
    isUpdatingClient: false,
    currentUser,
  }
}

function updateCompanyClientFailure(message) {
  return {
    type: UPDATE_COMPANY_CLIENT_FAILURE,
    isUpdatingClient: false,
    message,
  }
}

export function updateCompanyClient(lender_id, updates) {
  const token = localStorage.getItem('reggora_auth_token')
  console.log(updates)
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify(updates),
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/companies/manual_lender/${lender_id}`
    dispatch(updateCompanyClientRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(updateCompanyClientFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const currentUser = { ...getState().currentUser.currentUser }
              const clients = currentUser.company.company_clients
              for (let i = 0; i < clients.length; i++) {
                const client = clients[i]
                if (client.lender_id === lender_id) {
                  clients[i] = {
                    ...client,
                    lender: { ...client.lender, ...updates },
                  }
                  break
                }
              }
              dispatch(updateCompanyClientSuccess(currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function deleteCompanyClientRequest() {
  return {
    type: DELETE_COMPANY_CLIENT_REQUEST,
    isDeletingClient: true,
  }
}

function deleteCompanyClientSucess(currentUser) {
  return {
    type: DELETE_CLIENT_SUCCESS,
    isDeletingClient: false,
    currentUser,
  }
}

function deleteCompanyClientFailure(message) {
  return {
    type: DELETE_CLIENT_FAILURE,
    isDeletingClient: false,
    message,
  }
}

export function getCompanyAppraisers(offset, limit) {
  const authToken = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  return (dispatch, getState) => {
    dispatch(getCompanyAppraisersRequest())

    const currentUser = getState().currentUser
    const companyID = currentUser.currentUser.company.id
    const url = `${SERVER_BASE_URL}/api/orders/outstanding/${companyID}?offset=${offset}&limit=${limit}`
    return fetch(url, config)
      .then(response => {
        response.json().then(result => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(getCompanyAppraisersFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(getCompanyAppraisersSuccess(result))
            }
          }).catch((err) => console.log(err))
      })
  }
}

export function deleteCompanyClient(lender_id) {
  const token = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'DELETE',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  return (dispatch, getState) => {
    const company_id = getState().currentUser.currentUser.company.id
    const url = `${SERVER_BASE_URL}/api/companies/${company_id}/client?lender_id=${lender_id}`
    dispatch(deleteCompanyClientRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(deleteCompanyClientFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const currentUser = { ...getState().currentUser.currentUser }
              const clients = currentUser.company.company_clients
              currentUser.company.company_clients = clients.filter(client => {
                return client.lender_id !== lender_id
              })
              dispatch(deleteCompanyClientSucess(currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function createCompanyClientRequest() {
  return {
    type: CREATE_COMPANY_CLIENT_REQUEST,
    isCreatingCompanyClient: true,
  }
}

function createCompanyClientSuccess(currentUser) {
  return {
    type: CREATE_COMPANY_CLIENT_SUCCESS,
    isCreatingCompanyClient: false,
    currentUser,
  }
}

function createCompanyClientFailure(message) {
  return {
    type: CREATE_COMPANY_CLIENT_FAILURE,
    isCreatingCompanyClient: false,
    message,
  }
}

export function createCompanyClient(client) {
  const authToken = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'POST',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify(client),
  }
  return (dispatch, getState) => {
    dispatch(createCompanyClientRequest())
    const currentUser = getState().currentUser
    const companyID = currentUser.currentUser.company.id
    const url = `${SERVER_BASE_URL}/api/companies/${companyID}/client`
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(createCompanyClientFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const newCurrentUser = getState().currentUser.currentUser
              client.id = result.id
              newCurrentUser.company.company_clients = [
                ...newCurrentUser.company.company_clients,
                {
                  lender_id: result.id,
                  lender: client,
                  has_orders: false,
                  is_manual: true,
                  tags: [],
                },
              ]
              dispatch(createCompanyClientSuccess(newCurrentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}


function editCompanyClientTagsRequest() {
  return {
    type: EDIT_COMPANY_CLIENT_TAGS_REQUEST,
    isCreatingClient: true,
  }
}

function editCompanyClientTagsSuccess(currentUser) {
  return {
    type: EDIT_COMPANY_CLIENT_TAGS_SUCCESS,
    isCreatingClient: false,
    currentUser,
  }
}

function editCompanyClientTagsFailure(message) {
  return {
    type: EDIT_COMPANY_CLIENT_TAGS_FAILURE,
    isCreatingClient: false,
    message,
  }
}

export function editCompanyClientTags(subjectClient) {
  const token = localStorage.getItem('reggora_auth_token')
  const lender_id = subjectClient.lender_id
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: JSON.stringify({
      lender_id: lender_id,
      tags: subjectClient.tags,
    }),
    headers: {
      Authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    const id = getState().currentUser.currentUser.company.id
    const url = `${SERVER_BASE_URL}/api/companies/${id}/client`
    dispatch(editCompanyClientTagsRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(editCompanyClientTagsFailure(processError(result)))
              return Promise.reject(result)
            } else {
              const currentUser = { ...getState().currentUser.currentUser }
              const clients = currentUser.company.company_clients
              for (let i = 0; i < clients.length; i++) {
                const client = clients[i]
                if (client.lender_id === lender_id) {
                  clients[i] = {
                    ...client,
                    tags: subjectClient.tags,
                  }
                  break
                }
              }
              dispatch(editCompanyClientTagsSuccess(currentUser))
            }
          }).catch((err) => console.log(err))
      })
  }
}

function verifyInvitationEmailsRequest() {
  return {
    type: VERIFY_INVITATION_EMAILS_REQUEST,
    isVerifyingEmails: true,
  }
}

function verifyInvitationEmailsSuccess(invitationEmailErrors) {
  return {
    type: VERIFY_INVITATION_EMAILS_SUCCESS,
    isVerifyingEmails: false,
  }
}

function verifyInvitationEmailsFailure(message) {
  return {
    type: VERIFY_INVITATION_EMAILS_FAILURE,
    isVerifyingEmails: false,
    message,
  }
}

export function verifyInvitationEmails(data) {
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
      'content-type': 'application/json',
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/users/verify-invite-emails`
    dispatch(verifyInvitationEmailsRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(verifyInvitationEmailsFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(verifyInvitationEmailsSuccess())
            }
          }).catch((err) => console.log(err))
      })
  }
}


function submitUpdatedConsentRequest() {
  return {
    type: SUBMIT_UPDATED_CONSENT_REQUEST,
    isSubmittingConsent: true,
  }
}

function submitUpdatedConsentRequestSuccess() {
  return {
    type: SUBMIT_UPDATED_CONSENT_SUCCESS,
    isSubmittingConsent: false,
  }
}

function submitUpdatedConsentFailure(message) {
  return {
    type: SUBMIT_UPDATED_CONSENT_FAILURE,
    isSubmittingConsent: false,
    message,
  }
}

export function submitUpdatedConsent(data) {
  const config = {
    method: 'PUT',
    accept: 'application/json',
    body: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem('reggora_auth_token')}`,
    },
  }
  return (dispatch, getState) => {
    const url = `${SERVER_BASE_URL}/api/users/updatedTermsAndServices`
    dispatch(submitUpdatedConsentRequest())
    return fetch(url, config)
      .then((response) => {
        response.json().then((result) => ({ result, response }))
          .then(({ result, response }) => {
            if (!response.ok) {
              dispatch(submitUpdatedConsentFailure(processError(result)))
              return Promise.reject(result)
            } else {
              dispatch(submitUpdatedConsentRequestSuccess())
            }
          }).catch((err) => console.log(err))
      })
  }
}


function getCompanySuccess(company) {
  return {
    type: GET_COMPANY_SUCCESS,
    company,
  }
}

export function getCompany() {
  const authToken = localStorage.getItem('reggora_auth_token')
  if (typeof authToken !== 'string') { return }
  const userId = jwtDecode(authToken).user_id
  const companyUrl = `${SERVER_BASE_URL}/api/users/${userId}/company`
  const config = {
    method: 'GET',
    accept: 'application/json',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }

  return (dispatch) => {
    return fetch(companyUrl, config)
      .then((response) => {
        if (!response.ok) {
          return Promise.reject(response)
        } else {
          return response.json().then(company => {
            return dispatch(getCompanySuccess(company))
          })
        }
      }).catch(() => { /* continue regardless of error */ })
  }
}
